<template>
  <div>
    <el-table :data="list" border size="small" v-loading="loading" height="600px">
      <el-table-column label="店铺" width="250" fixed>
        <template slot-scope="scope">
          <div style="font-size:14px;color:#333;font-weight:600;">{{ scope.row.projectName }}</div>
          <div style="color:#909399;font-size:12px;">{{ scope.row.storeName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="日期" prop="date" width="105"></el-table-column>
      <el-table-column label="运营师" width="110">
        <template slot-scope="scope">
          {{ scope.row.yunyingNames.length ? scope.row.yunyingNames.join('、') : '未分配' }}
        </template>
      </el-table-column>

      <!-- 总体数据 -->
      <el-table-column label="总体数据" align="center">
        <el-table-column
          v-for="col in totalCols" :key="'t-'+col.label"
          :label="col.label" :width="col.width">
          <template slot-scope="scope"><cell :row="scope.row" :render="col.render"></cell></template>
        </el-table-column>
      </el-table-column>

      <!-- 爆品团 -->
      <el-table-column label="爆品团" align="center">
        <el-table-column
          v-for="col in subCols" :key="'s-'+col.label"
          :label="col.label" :width="col.width">
          <template slot-scope="scope"><cell :row="scope.row" :render="col.render"></cell></template>
        </el-table-column>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagenum"
      :page-sizes="[20, 50, 100]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 12px; text-align: right"
    ></el-pagination>
  </div>
</template>

<script>
import { totalColumns, subColumns } from './dataColumns'

const Cell = {
  functional: true,
  props: { row: Object, render: Function },
  render (h, ctx) {
    return ctx.props.render(h, ctx.props)
  }
}

export default {
  name: 'TaobaoDataTab',
  components: { Cell },
  props: {
    query: { type: Object, required: true }
  },
  data () {
    return {
      list: [],
      total: 0,
      pagenum: 1,
      pagesize: 20,
      loading: false,
      totalCols: totalColumns(),
      subCols: subColumns()
    }
  },
  watch: {
    query: {
      deep: true,
      handler () {
        this.pagenum = 1
        this.getList()
      }
    }
  },
  methods: {
    async getList () {
      this.loading = true
      try {
        const params = { pagenum: this.pagenum, pagesize: this.pagesize, ...this.query }
        Object.keys(params).forEach(k => {
          if (params[k] === '' || params[k] === null) delete params[k]
        })
        const { data: res } = await this.$http.get('yunying/data/taobao', { params })
        if (res.meta.status !== 200) { this.$message.error(res.meta.msg); return }
        this.list = res.data.list || []
        this.total = res.data.total || 0
        // 上抛当前用户权限标记，供父组件控制筛选区显隐
        this.$emit('my-rights', res.data.myRights || { isSelfOnly: false })
      } catch (e) {
        this.$message.error('获取淘宝闪购运营数据失败')
      } finally {
        this.loading = false
      }
    },
    handleSizeChange (v) { this.pagesize = v; this.pagenum = 1; this.getList() },
    handleCurrentChange (v) { this.pagenum = v; this.getList() }
  }
}
</script>
